function ShimmerBar({ className }: { className?: string }) {
  return (
    <div
      className={`rounded animate-shimmer ${className ?? "h-4"}`}
      style={{ minHeight: "1rem" }}
    />
  );
}

export function RouteFallback() {
  return (
    <div className="flex flex-col gap-6 w-full max-w-[1240px] mx-auto mt-6 px-4">
      {/* Page title shimmer */}
      <div className="flex flex-col gap-2">
        <ShimmerBar className="h-8 w-64" />
      </div>

      {/* Card row shimmers */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="rounded-lg border border-stroke p-5 flex flex-col gap-3 min-h-[180px]"
          >
            <ShimmerBar className="h-5 w-32" />
            <ShimmerBar className="h-8 w-24" />
            <ShimmerBar className="h-4 w-full" />
            <ShimmerBar className="h-4 w-3/4" />
          </div>
        ))}
      </div>

      {/* Second row - wider card */}
      <div className="rounded-lg border border-stroke p-5 flex flex-col gap-3 min-h-[120px]">
        <ShimmerBar className="h-5 w-40" />
        <div className="flex gap-4 mt-2">
          <ShimmerBar className="h-16 w-32 rounded-lg" />
          <ShimmerBar className="h-16 w-32 rounded-lg" />
          <ShimmerBar className="h-16 w-32 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
